import { Link } from 'react-router-dom';
import { homeViewFor, labelForView, pathForView, type ViewId } from '@aithora/shared';
import { useConsoleRole, useSession } from '../session/SessionContext';

/** A page that has not moved to the React console yet. */
export function Placeholder({ view }: { view: ViewId }) {
  return (
    <section className="placeholder" aria-labelledby="ph-title">
      <h2 id="ph-title" className="placeholder__title">
        {labelForView(view)}
      </h2>
      <p className="placeholder__body">This page has not moved to the new console yet. The current console still has it.</p>
    </section>
  );
}

/** The URL named a page this role does not open. The role never comes from the URL. */
export function NoAccess() {
  const { session } = useSession();
  const { role } = useConsoleRole();
  const home = homeViewFor(role);
  return (
    <section className="placeholder" aria-labelledby="na-title">
      <h2 id="na-title" className="placeholder__title">
        Not available for your role
      </h2>
      <p className="placeholder__body">
        {role
          ? 'Your role does not open this page. If you need it, ask your administrator.'
          : `This account's role (${session?.user.rawRole ?? 'unknown'}) has no console pages. Ask Aithora to check it.`}
      </p>
      {home && (
        <Link className="btn btn--secondary" to={pathForView(home)}>
          Go to {labelForView(home)}
        </Link>
      )}
    </section>
  );
}
